import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPopups } from '../selectors';

import { createSpinnerPopup } from '../actions/popup';
import { createAddCollection } from '../actions/collection';

import Header from './Header';
import MainSection from './MainSection';

import ErrorBoundary from '../components/ErrorBoundary';
import Overlay from '../components/Overlay';
import CollectionsPage from '../components/CollectionsPage';

import CreateShop from '../components/shop/Creation/CreateShop';

class CollectionsApp extends Component {

  render() {
    const { identity, popups, onAddCollection, create_shop } = this.props;
    const hasCapability = capability => identity.capabilities.includes(capability);

    return (
      <ErrorBoundary>
        <Header>
          <div className="columns">
            <h4 style={{ display: 'inline-block' }}>Product Collections</h4>
            {hasCapability('CREATE-COLLECTION') ?
              <a className="button" style={{ float: 'right' }} onClick={e => onAddCollection()}>Create Collection</a> :
              null}
          </div>
        </Header>
        <MainSection popups={popups}>
          <CollectionsPage identity={identity} />
        </MainSection>
        {create_shop ? <CreateShop /> : null}
        <Overlay popups={popups} />
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  identity: state.identity,
  popups: getPopups(state),
  create_shop: state.temp.create_shop
});

const mapDispatchToProps = dispatch => ({
  onAddCollection: () => Promise.resolve(dispatch(createSpinnerPopup('Creating Collection...'))).then(
    () => dispatch(createAddCollection())
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsApp);
